import { render } from "./LegoStepStore.vue?vue&type=template&id=2f4e9667"
import script from "./LegoStepStore.vue?vue&type=script&lang=js"
export * from "./LegoStepStore.vue?vue&type=script&lang=js"
script.render = render

export default script